//
// Variables
// =========
export const baseSpacer = '1rem';
export const baseFieldPadding = '0.75rem';
export const baseBorderWidth = '1px';
export const baseBorderRadius = '4px';
export const baseBorderRadiusS = '3px';
export const baseStrokeWidth = '4px';
export const baseShadowCast = '2px';
export const baseShadowBlur = '4px';

export const basePlaceholderOpacity = '0.4';
export const baseDisabledFieldOpacity = '0.4';
export const baseContainerShadowBlur = '12px';

export const iconSizeDefault = '21px';

export const containerPaddingXs = '0.25rem';
export const containerPaddingS = '0.5rem';
export const containerPaddingSm = '0.75rem';
export const containerPaddingM = baseSpacer;
export const containerPaddingMl = '1.5rem';
export const containerPaddingL = '2rem';
export const containerPaddingXL = '3rem';

export const containerBorderRadiusM = baseBorderRadius;
export const containerBorderRadiusL = '8px';

export const paragraphSpacing = baseSpacer;

export const buttonSmallPaddingS = '0.5rem';
export const buttonSmallPaddingM = '1rem';
export const buttonSmallPaddingL = '2rem';
export const buttonMediumPaddingS = '0.75rem';
export const buttonMediumPaddingM = '1.5rem';
export const buttonMediumPaddingL = '2.5rem';
export const buttonLargePaddingS = '1.25rem';
export const buttonLargePaddingM = '2.25rem';
export const buttonLargePaddingL = '3.25rem';
export const buttonIconSmallPadding = '0.25rem';
export const buttonIconMediumPadding = '0.75rem';
export const buttonIconLargePadding = '1.25rem';

export const uiTransitionDurationXs = '50ms';
export const uiTransitionDurationShort = '100ms';
export const uiTransitionDurationNormal = '250ms';
export const uiTransitionDurationLong = '400ms';
export const uiTransitionDurationExtraLong = '750ms';

export const formElementDefaultWidth = '15rem';
export const formElementMaxWidth = '22rem';

export const formQuestionMarginBottom = '2.875em';
export const formQuestionHeight = '2.75em';
export const formQuestionFontSize = '16px';

export const formLogoPaddingTop = '1rem';
export const formLogoPaddingBottom = '2rem';

export const EDITOR_SIDEBAR_WIDTH = '300px';
export const WORKSPACE_TOPBAR_HEIGHT = '63px';
